<template>
    <v-card-title class="headline v-flex primary white--text" >
        <div>
            <span class="mr-1" v-if="icon"><v-icon color="white" size="22">{{ icon }}</v-icon></span>
            <span>{{ title }}</span>
        </div>
        <v-spacer />
        <slot name="toolbar" />
        <a @click="onCancel">
            <v-icon size="22" color="white">mdi-close</v-icon>
        </a>
    </v-card-title>
</template>

<script>
export default {
    name: "FDialogTitle",

    props: {
        icon: {
            default: function () {
                return null;
            }
        },

        title: {
            required: true,
            type    : String
        }
    },

    methods: {
        onCancel () {
            this.$emit("cancel");
        }
    }
}
</script>

<style scoped>

.headline {
    font-size: 16px!important;
    height: 35px;
    padding-top: 1px!important;
    padding-right: 10px!important;
    padding-left: 10px!important;
}

</style>